import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../../services/instance'
import { GSTR3B_GET_FORM_DATA, GSTR3B_GET_CELL_DATA, GSTR3B_ADD_COMMENT, GSTR3B_UPLOAD_FILES, HANDLE_GSTR3B_SHEET_APPROVAL, HANDLE_MANAGER_GSTR3B_SHEET_APPROVAL } from '../../constants/services'
import { extractErrorMessage } from '../../components/common/helperFunction'
import toast from "react-hot-toast";
export const fetchFormData = createAsyncThunk(
    'gstr3bSlice/fetchFormData',
    async ({ month, year }, thunkAPI) => {
        const response = await axiosInstance.post(GSTR3B_GET_FORM_DATA, { month, year })
        return response.data
    },
)

export const getCommentDetails = createAsyncThunk(
    'gstr3bSlice/getCommentDetails',
    async ({ month, year, cell }, thunkAPI) => {
        const response = await axiosInstance.post(GSTR3B_GET_CELL_DATA, { month, year, cell })
        return response.data
    },
)

export const addCommentDetails = createAsyncThunk(
    'gstr3bSlice/addCommentDetails',
    async ({ month, year, cell, comment }, thunkAPI) => {
        const response = await axiosInstance.post(GSTR3B_ADD_COMMENT, { month, year, cell, comment, status: 2 })
        return response.data
    },
)

export const uploadFiles = createAsyncThunk(
    'gstr3bSlice/uploadFiles',
    async ({ month, year, files, section_type, notes }, thunkAPI) => {
        const formData = new FormData();
        files.forEach(file => formData.append('files', file));
        //formData.append('files[]', files);
        formData.append('month', month)
        formData.append('year', year)
        formData.append('section_type', section_type)
        formData.append('notes', notes)
        const response = await axiosInstance.post(GSTR3B_UPLOAD_FILES, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Set the content type
            }
        })
        return response.data
    },
)

export const handleSheetApproval = createAsyncThunk(
    'gstr3bSlice/handleSheetApproval',
    async ({ month, year, approve, isManager, sheetId }, thunkAPI) => {
        try {
            let response = {};
            response = await axiosInstance.post(HANDLE_GSTR3B_SHEET_APPROVAL, { month, year, approve });
            return response.data
        } catch (error) {
            // Log the error for debugging
            console.error('Error in handleSheetApproval:', error);
            const errorMessage = extractErrorMessage(error);
            toast.error(errorMessage);
            // Return the error message or a custom error
            return thunkAPI.rejectWithValue(error.response ? error.response.data : 'Something went wrong');
        }
    },
)

export const handleSheetApprovalManager = createAsyncThunk(
    'gstr3bSlice/handleSheetApprovalManager',
    async ({ month, year, approve, isManager, sheetId }, thunkAPI) => {
        try {
            let response = {};
            response = await axiosInstance.post(`${HANDLE_MANAGER_GSTR3B_SHEET_APPROVAL}/${sheetId}`, { month, year, approve });
            return response.data
        } catch (error) {
            // Log the error for debugging
            console.error('Error in handleSheetManagerApproval:', error);
            const errorMessage = extractErrorMessage(error);
            toast.error(errorMessage);
            // Return the error message or a custom error
            return thunkAPI.rejectWithValue(error.response ? error.response.data : 'Something went wrong');
        }
    },
)
const currentDate = new Date();
export const gstr3bSlice = createSlice({
    name: 'gstr3b',
    initialState: {
        excelData: {
            url: '',
            summary: [],
            comments: []
        },
        currentCommentCell: null,
        currentComment: '',
        successMsg: '',
        errorMsg: '',
        uploadFilesSuccess: false,
        billsUploading: false,
        uploadFilesData: {},
        handleSheetApprovalState: { success: false, data: [], error: null }
    },
    reducers: {
        clearMessages: (state) => {
            state.successMsg = ''
            state.errorMsg = ''
            state.currentCommentCell = ''
            state.currentComment = ''
            state.uploadFilesSuccess = false
            state.billsUploading = false
            state.uploadFilesData = {}
            state.handleSheetApprovalState = { success: false, data: [], error: null }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchFormData.fulfilled, (state, action) => {
            const { sheet, summery, all_comments } = action.payload.data;
            if (sheet && sheet.url) {
                state.excelData.url = sheet.url
            } else {
                state.excelData.url = ''
            }
            state.excelData.summary = summery
            state.excelData.comments = all_comments
        })
        builder.addCase(getCommentDetails.fulfilled, (state, action) => {
            const { cell_no, comments } = action.payload.data
            state.currentComment = comments
            state.currentCommentCell = cell_no
        })
        builder.addCase(addCommentDetails.fulfilled, (state, action) => {
            state.successMsg = 'Successfully Added comment'
        })
        builder.addCase(addCommentDetails.rejected, (state, action) => {
            state.errorMsg = 'Failed to add comment'
        })
        builder.addCase(uploadFiles.pending, (state) => {
            state.successMsg = 'Uploading...';
            state.uploadFilesSuccess = false;
            state.billsUploading = true;
        })
        builder.addCase(uploadFiles.fulfilled, (state, action) => {
            state.successMsg = 'Successfully uploaded file(s)'
            state.uploadFilesSuccess = true;
            state.uploadFilesData = action.payload;
            state.billsUploading = false;
        })
        builder.addCase(uploadFiles.rejected, (state, action) => {
            state.errorMsg = 'Failed to upload file(s)'
            state.uploadFilesSuccess = false;
            state.billsUploading = false;
        })
        builder.addCase(handleSheetApproval.fulfilled, (state, action) => {
            state.handleSheetApprovalState.success = true
            state.handleSheetApprovalState.data = action.payload
            state.handleSheetApprovalState.error = null
        })
        builder.addCase(handleSheetApproval.rejected, (state, action) => {
            state.handleSheetApprovalState.success = false
            state.handleSheetApprovalState.data = action.payload;
            state.handleSheetApprovalState.error = true
        })
        builder.addCase(handleSheetApprovalManager.fulfilled, (state, action) => {
            state.handleSheetApprovalState.success = true
            state.handleSheetApprovalState.data = action.payload
            state.handleSheetApprovalState.error = null
        })
        builder.addCase(handleSheetApprovalManager.rejected, (state, action) => {
            state.handleSheetApprovalState.success = false
            state.handleSheetApprovalState.data = action.payload;
            state.handleSheetApprovalState.error = true
        })
    },
})




export const { clearMessages } = gstr3bSlice.actions


export default gstr3bSlice.reducer